/* ---------------------------------------------------------------------------
 * Caliante Wishlist
 * ---------------------------------------------------------------------------
 * Speichert gemerkte Produkte im localStorage des Besuchers - kein Login, keine
 * App, kein Fremd-Skript. Meldet jede Änderung zusätzlich an Klaviyo, damit sich
 * dort Erinnerungs-Strecken bauen lassen.
 *
 * Wichtig zur Reichweite der Klaviyo-Events: Klaviyo kann ein Event nur einem
 * Profil zuordnen, wenn die Besucherin bereits identifiziert ist (aus einer Mail
 * gekommen, Formular abgeschickt, oder eingeloggt). Anonyme Besucherinnen merken
 * Produkte trotzdem - nur eine Erinnerungs-Mail bekommen sie eben nicht.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  var KEY = 'caliante_wishlist_v1';
  var EVENT = 'cb:wishlist:change';

  /* ---------- Speicher ---------- */

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      // Privater Modus oder voller Speicher: Wishlist ist dann eben leer,
      // die Seite darf daran nicht scheitern.
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      return false;
    }
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { list: list } }));
    return true;
  }

  function has(id) {
    id = String(id);
    return read().some(function (item) { return String(item.id) === id; });
  }

  function add(item) {
    var list = read();
    if (list.some(function (x) { return String(x.id) === String(item.id); })) return list;
    item.addedAt = Date.now();
    list.unshift(item);
    write(list);
    track('Added to Wishlist', item);
    return list;
  }

  function remove(id) {
    var list = read();
    var gone = list.filter(function (x) { return String(x.id) === String(id); })[0];
    var next = list.filter(function (x) { return String(x.id) !== String(id); });
    write(next);
    if (gone) track('Removed from Wishlist', gone);
    return next;
  }

  function toggle(item) {
    if (has(item.id)) { remove(item.id); return false; }
    add(item);
    return true;
  }

  /* ---------- Klaviyo ---------- */

  function props(item) {
    return {
      ProductName: item.title,
      ProductID: item.id,
      Handle: item.handle,
      URL: location.origin + item.url,
      ImageURL: item.image || '',
      Price: item.price != null ? item.price / 100 : null,
      Currency: item.currency || 'EUR',
      WishlistCount: read().length
    };
  }

  function track(eventName, item) {
    var k = window.klaviyo;
    try {
      // Moderne SDK-Form. Klaviyo puffert Events anonymer Besucherinnen selbst und
      // schickt sie nach, sobald ein Profil identifiziert ist.
      if (k && typeof k.track === 'function') { k.track(eventName, props(item)); return; }
      var q = k || window._learnq;
      if (q && typeof q.push === 'function') q.push(['track', eventName, props(item)]);
    } catch (e) { /* Klaviyo darf die Wishlist nie blockieren */ }
  }

  /* Identifiziert die Besucherin in Klaviyo und meldet die gesamte Merkliste nach.
     Erst danach koennen Erinnerungs-Strecken sie ueberhaupt erreichen. */
  function identify(email) {
    var k = window.klaviyo;
    if (!k || !email) return Promise.resolve(false);
    try {
      var p = (typeof k.identify === 'function') ? k.identify({ email: email }) : null;
      var done = (p && typeof p.then === 'function') ? p : Promise.resolve();
      return done.then(function () {
        var list = read();
        if (typeof k.track === 'function') {
          k.track('Saved Wishlist', {
            WishlistCount: list.length,
            Items: list.map(function (i) { return { ProductName: i.title, ProductID: i.id, URL: location.origin + i.url, ImageURL: i.image || '' }; })
          });
        }
        return true;
      }).catch(function () { return false; });
    } catch (e) { return Promise.resolve(false); }
  }

  /* ---------- Oberfläche ---------- */

  function syncButton(btn) {
    var active = has(btn.dataset.wishlistId);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = active ? btn.dataset.labelRemove : btn.dataset.labelAdd;
    if (label) {
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
      var text = btn.querySelector('[data-wishlist-text]');
      if (text) text.textContent = label;
    }
  }

  function syncAll() {
    document.querySelectorAll('[data-wishlist-id]').forEach(syncButton);
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.toggleAttribute('hidden', n === 0);
    });
    document.querySelectorAll('[data-wishlist-dot]').forEach(function (el) {
      el.classList.toggle('is-visible', n > 0);
    });
  }

  /* ---------- Verdrahtung ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();          // sonst öffnet der Klick die Produktseite darunter
    toggle({
      id: btn.dataset.wishlistId,
      handle: btn.dataset.wishlistHandle,
      title: btn.dataset.wishlistTitle,
      url: btn.dataset.wishlistUrl,
      image: btn.dataset.wishlistImage,
      price: btn.dataset.wishlistPrice ? parseInt(btn.dataset.wishlistPrice, 10) : null,
      currency: btn.dataset.wishlistCurrency
    });
  });

  document.addEventListener(EVENT, syncAll);
  // Zweiter Tab, gleiche Wishlist.
  window.addEventListener('storage', function (e) { if (e.key === KEY) syncAll(); });
  // Nach Varianten-Rerender oder nachgeladenen Karten neu abgleichen.
  document.addEventListener('shopify:section:load', syncAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  window.CalianteWishlist = { read: read, has: has, add: add, remove: remove, toggle: toggle, sync: syncAll, identify: identify, EVENT: EVENT };
})();
